import { useState } from "react";
import type { HotspotSpec } from "../scenario/types";
import { tx } from "../lib/tx";

/**
 * Lightweight HTML markers over the 3D canvas. Positions are author-tuned
 * percentages (not projected 3D) so they stay stable across window sizes.
 */
export function RoomHotspots({
  hotspots,
  onInspect,
}: {
  hotspots: HotspotSpec[];
  onInspect?: (id: string) => void;
}) {
  const [openId, setOpenId] = useState<string | null>(null);
  if (!hotspots.length) return null;
  const open = hotspots.find((h) => h.id === openId) ?? null;

  return (
    <div className="hotspot-layer" aria-label={tx("Room hotspots")}>
      {hotspots.map((h) => (
        <button
          key={h.id}
          type="button"
          className={`hotspot-pin ${openId === h.id ? "on" : ""}`}
          style={{ left: `${h.xPct}%`, top: `${h.yPct}%` }}
          onClick={() => {
            setOpenId(h.id === openId ? null : h.id);
            onInspect?.(h.id);
          }}
        >
          <span className="hotspot-dot" aria-hidden />
          <span className="hotspot-label">{h.label}</span>
        </button>
      ))}
      {open && (
        <div className="hotspot-panel">
          <strong>{open.label}</strong>
          {open.detail && <p>{open.detail}</p>}
          <button type="button" className="btn hotspot-close" onClick={() => setOpenId(null)}>
            {tx("Close")}
          </button>
        </div>
      )}
    </div>
  );
}
